import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { SignInModal } from './sign-in.modal';

interface Props {
  isLoggedIn: boolean;
}

export const SignInPrompt: React.FC<Props> = ({ isLoggedIn }) => {
  const history = useHistory();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [redirectPath, setRedirectPath] = useState('');

  useEffect(() => {
    const unregister = history.block(location => {
      const path = location.pathname;
      const requiresSignIn = path.toLowerCase().indexOf('/profile') >= 0;
      if (requiresSignIn && !isLoggedIn) {
        setShowLoginModal(true);
        setRedirectPath(path);
        return false;
      } else return;
    });

    return () => unregister();
  }, [history, isLoggedIn]);

  return (
    <>
      {showLoginModal && (
        <SignInModal
          show={true}
          redirectPath={redirectPath}
          onClose={() => {
            setShowLoginModal(false);
          }}
        />
      )}
    </>
  );
};
